import { useQuery } from '@tanstack/react-query';
import { domainService } from '../../../services/domainService';
import { subscriptionService } from '../../../services/subscriptionService';
import { notificationService } from '../../../services/notificationService';
import { dashboardService } from '../../../services/dashboardService';
import { useSessionGate } from '../../../hooks/useSessionGate';

export const useDashboard = () => {
  const { expired } = useSessionGate();

  // ドメイン一覧
  const domainsQuery = useQuery({
    queryKey: ['domains', { limit: 5 }],
    queryFn: () => domainService.getDomains({ limit: 5 }, { skipGlobalErrorToast: true }),
    enabled: !expired,
  });

  // サブスクリプション情報
  const subscriptionQuery = useQuery({
    queryKey: ['subscription'],
    queryFn: () => subscriptionService.getSubscription(),
    enabled: !expired,
  });

  // 通知
  const notificationsQuery = useQuery({
    queryKey: ['notifications', { limit: 5, unread_only: true }],
    queryFn: () => notificationService.getNotifications({ limit: 5, unread_only: true }),
    enabled: !expired,
  });

  // ダッシュボード統計（訪問者数/チャット利用者数/メッセージ数）
  const statsQuery = useQuery({
    queryKey: ['dashboardStats'],
    queryFn: () => dashboardService.getStats(),
    enabled: !expired,
  });

  return {
    domains: domainsQuery.data?.data || [],
    domainsLoading: domainsQuery.isLoading,
    domainsFetched: domainsQuery.isFetched,
    subscription: subscriptionQuery.data?.data || null,
    subscriptionLoading: subscriptionQuery.isLoading,
    notifications: notificationsQuery.data?.data?.notifications || [],
    notificationsLoading: notificationsQuery.isLoading,
    unreadCount: notificationsQuery.data?.data?.unread_count || 0,
    stats: statsQuery.data?.data || null,
    statsLoading: statsQuery.isLoading,
  };
};
